import { gql } from '@apollo/client';

export const DELETE_WORKSPACE = gql`
  mutation DeleteWorkspace($id: ID!) {
    programme: deleteWorkspace(id: $id) {
      id
      name
    }
  }
`;
